import ErrorIcon from "@mui/icons-material/Error";

import Button from "components/common/Button";

import "./ImageCropperErrorModal.scss";

interface ImageCropperErrorModalProps {
  closeModal: () => void;
}

function ImageCropperErrorModal({ closeModal }: ImageCropperErrorModalProps) {
  return (
    <div className="image-cropper-error-modal">
      <div className="error-modal-container">
        <div className="error-icon">
          <ErrorIcon color="error" data-testid="ErrorIcon" />
        </div>
        <h2 className="error-title heading-h1-semibold m-0">Oops! That image is too big</h2>
        <p className="error-message">Try uploading a file under 2MB.</p>
        <div className="error-action">
          <Button label="Close" onClick={closeModal} variant="text" color="primary" size="large" />
        </div>
      </div>
    </div>
  );
}

export default ImageCropperErrorModal;
